(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5159],{

/***/ 41227:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]",
      function () {
        return __webpack_require__(12425);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73912);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);






/**
 * Primary UI component for text input
 */ const TextInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , validations , required , type ="text" , border ="border" , onKeyDown , onBlur , max , min , textColour , disabled , testid , name , tooltip , show =true , customClassLabel ="" , error =undefined , setError , autoComplete , ignoreDefaultValidations =false , variation ="v1" , forceLabel =false , disableInlineErrors =false  } = param;
    const fieldTypeValidations = ignoreDefaultValidations ? validations : (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultValidations */ .C)(type, validations);
    let errorMessage = error !== null && error !== void 0 ? error : (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, fieldTypeValidations);
    // if (errorMessage)
    // console.log({ errMessage: errorMessage, fieldTypeValidations })
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true);
    const [showPassword, setShowPassword] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        // Autohide tooltip if the input is not required.
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.toLowerCase().includes("require")) && !required) setShowTooltip(false);
    }, [
        tooltip,
        required
    ]);
    // useEffect(() => {
    //   if (errorMessage) console.log({ errorMessage, fieldTypeValidations })
    // }, [errorMessage])
    if (value === null) value = "";
    const generateStyles = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        let base = "transition-all outline-none rounded bg-white/70 focus:ring-0";
        let errorStyles = errorMessage ? "text-red-500 border-red-500 focus:border-red-500" : "border-gray-300 focus:border-forumm-blue";
        const disabledStyles = disabled ? "!text-gray-500 bg-gray-100 border-gray-300 cursor-not-allowed" : "";
        let textStyles = "text-sm placeholder-gray-500";
        let positionStyles = "h-11 px-3 py-2";
        let sizeStyles = "w-full";
        const passwordStyles = type === "password" ? "pr-11" : "";
        if (variation === "v2") {
            base = "!bg-white rounded-none border-black";
            errorStyles = errorMessage ? "text-red-500 border-red-500" : "";
            textStyles = "text-sm placeholder-black font-semibold";
            positionStyles = "px-4 py-4";
        }
        const payload = "".concat(base, " ").concat(textStyles, " ").concat(positionStyles, " ").concat(border, " ").concat(errorStyles, " ").concat(disabledStyles, " ").concat(passwordStyles, " ").concat(sizeStyles, " ").concat(className);
        return payload;
    }, [
        border,
        className,
        disabled,
        errorMessage,
        type,
        variation
    ]);
    const input = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            "data-testid": testid !== null && testid !== void 0 ? testid : null,
            required: required,
            value: value,
            onKeyDown: onKeyDown,
            onBlur: onBlur,
            onChange: (e)=>{
                const val = e.target.value;
                errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(val, fieldTypeValidations);
                // console.log({ errorMessage, target: val, fieldTypeValidations })
                // setErrorMessage(errorMsg ?? '')
                const isInvalid = errorMessage !== "";
                var ref;
                if (!!setError && typeof errorMessage === "string") setError(errorMessage, (ref = testid !== null && testid !== void 0 ? testid : label) !== null && ref !== void 0 ? ref : "unknown");
                if (!!onChange) onChange(val, isInvalid);
            },
            max: max,
            disabled: disabled,
            min: min,
            type: showPassword ? "text" : type,
            placeholder: placeholder,
            autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : label,
            id: label,
            className: generateStyles,
            style: {
                color: textColour
            }
        }), [
        testid,
        required,
        value,
        onKeyDown,
        onBlur,
        onChange,
        max,
        disabled,
        min,
        type,
        placeholder,
        autoComplete,
        label,
        generateStyles,
        textColour,
        errorMessage,
        fieldTypeValidations,
        setError,
        showPassword
    ]);
    const labelRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const showLabel = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>label && variation === "v1" || forceLabel, [
        label,
        variation,
        forceLabel
    ]);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col my-3",
            className
        ].join(" "),
        style: {
            color: textColour
        },
        children: [
            showLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                ref: labelRef,
                className: "mb-1.5 text-sm font-medium leading-5 transition-all ".concat(errorMessage ? "text-red-500" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    show: showTooltip,
                    tooltip: tooltip,
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "z-10 \n                ".concat(variation === "v2" ? "text-black font-semibold" : "", "\n                ").concat(customClassLabel, " \n                ").concat(required ? "after:content-['*'] after:ml-1 after:text-red-500" : ""),
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "relative",
                children: [
                    input,
                    type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "absolute right-3 top-1/2 flex -translate-y-1/2 cursor-pointer items-center text-lg",
                        onClick: ()=>setShowPassword(!showPassword),
                        children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdVisibility */ .t2l, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdVisibilityOff */ .wqE, {})
                    })
                ]
            }),
            errorMessage && !disableInlineErrors && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                textColour: "foregroundTextColour",
                className: "transition-all text-red-500 text-xs font-bold mt-1",
                children: errorMessage
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                style: {
                    color: textColour
                },
                children: hint
            })
        ]
    });
};


/***/ }),

/***/ 26052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MediaThumbnail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40654);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63696);
/* harmony import */ var _components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38999);





const MediaThumbnail = (param)=>{
    let { show =true , style ={} , media , key , size ="sm" , className ="" , alt , timeout =3000 , onClick =(e)=>{}  } = param;
    const [thumbnail, setThumbnail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const sizeClasses = {
        any: "",
        xs: "h-6 w-6",
        sm: "h-8 w-8",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (async ()=>{
            if (media) {
                setLoading(true);
                await (0,_libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_1__/* .getContentThumbnail */ .Lb)(media).then((data)=>{
                    setThumbnail(data);
                    setLoading(false);
                }).catch((err)=>{
                    console.error(err);
                    setLoading(false);
                });
            }
        })();
    }, [
        media
    ]);
    setTimeout(()=>setLoading(false), timeout);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (!thumbnail && loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_LoadingSpinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    if (!thumbnail) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_images_ForummLogo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "".concat(sizeClasses[size], " ").concat(className)
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        style: style,
        onClick: (e)=>onClick(e),
        className: "".concat(sizeClasses[size], " ").concat(className, " object-cover"),
        alt: alt !== null && alt !== void 0 ? alt : "Media thumbnail",
        src: thumbnail,
        draggable: false
    }, key);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1458,9198,7632,9041,5121,3913,6514,170,2425,9774,2888,179], function() { return __webpack_exec__(41227); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);